import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref } from '../../../../adapter-vue';
import { TUITranslateService, IMessageModel } from '@tencentcloud/chat-uikit-engine';
import { isUrl, JSONToObject } from '../../../../utils/index';
import { CHAT_MSG_CUSTOM_TYPE } from '../../../../constant';
import { ICustomMessagePayload } from '../../../../interface';
import Icon from '../../../common/Icon.vue';
import star from '../../../../assets/icon/star-light.png';
import td from '../../../../assets/tulkit/td.png';
import { getCurrentInstance } from '../../../../adapter-vue';
import axios from '@/libs/api.request';
interface Props {
  messageItem: IMessageModel;
  content: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'message-custom',
  props: {
    messageItem: { default: undefined },
    content: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { messageItem: IMessageModel, content: any }

const thisInstance = getCurrentInstance()?.proxy || getCurrentInstance();


const custom = ref();
const message = ref<IMessageModel>();
const extension = ref();
const isCustom = ref<ICustomMessagePayload>({
  businessID: ''
});
const toInterview = (interview: any) => {
  thisInstance.$eventBus.$emit('closeChat');
  thisInstance.$router.push({
    name: 'interviewIndex',
    query: {
      id: interview.id
    }
  });
};
watchEffect(() => {
  custom.value = props.content;
  message.value = props.messageItem;
  const { payload } = props.messageItem;
  isCustom.value = payload.data || '';
  isCustom.value = JSONToObject(payload.data);
  if (payload.data === CHAT_MSG_CUSTOM_TYPE.SERVICE) {
    extension.value = JSONToObject(payload.extension);
  }
});
const openLink = (url: any) => {
  window.open(url);
};
const download = () => {
  axios
    .request({
      methods: 'get',
      url: '/front/v1/common/file/getPetUrl/' + isCustom.value.id
    })
    .then(res => {
      if (res.code !== 200) return;
      axios
        .request({
          methods: 'get',
          url: '/front/v1/common/file/downResume/' + isCustom.value.id,
          responseType: 'blob'
        })
        .then(e => {
          let a = document.createElement('a');
          a.href = window.URL.createObjectURL(e);
          a.download = isCustom.value.text;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
        });
    });
};

return { __sfc: true,thisInstance, props, custom, message, extension, isCustom, toInterview, openLink, download, TUITranslateService, isUrl, CHAT_MSG_CUSTOM_TYPE, Icon, star, td }
}

})